import type { CategoryContent } from '../row.js';

export const PHARMACEUTICALS: CategoryContent = {
  bscba: [
    [
      'Waar staat ADME voor in de farmacokinetiek?',
      [
        'Absorptie, Distributie, Metabolisme, Uitscheiding',
        'Acetylering, Deaminering, Methylering, Verestering',
        'Activering, Afbraak, Modificatie, Eliminatie',
        'Adherentie, Dosering, Monitoring, Werkzaamheid',
      ],
      0,
      'ADME beschrijft de vier fundamentele processen waarmee het lichaam een geneesmiddel verwerkt.',
    ],
    [
      'Welk type medicijnreceptor werkt doorgaans via G-proteïnekoppeling?',
      [
        'GPCRs',
        'Ionkanaalreceptoren',
        'Kernreceptoren',
        'Enzym-gekoppelde receptoren',
      ],
      0,
      'GPCRs activeren intracellulaire signalering via heterotrimerige G-eiwitten en vormen de grootste receptorfamilie.',
    ],
    [
      'Wat is het primaire doel van klinische proeven in Fase II?',
      [
        'Werkzaamheid en optimale dosering beoordelen',
        'Lange-termijnveiligheid in grote populaties evalueren',
        'Basisveiligheid en verdraagzaamheid in gezonde vrijwilligers vaststellen',
        'Zeldzame bijwerkingen in reële praktijk bewaken',
      ],
      0,
      'Fase II-proeven beoordelen werkzaamheid en dosis-respons in kleine patiëntgroepen met werkzaamheidsparameters.',
    ],
    [
      'Welk antibioticum werd door Alexander Fleming toevallig ontdekt bij contaminatie?',
      [
        'Penicilline',
        'Streptomycine',
        'Chloramfenicol',
        'Tetracycline',
      ],
      0,
      'Flemings waarneming uit 1928 van schimmel die bacteriegroei remt leidde tot penicilline.',
    ],
    [
      'Wat beschrijft het proces waarbij een geneesmiddel na toediening in de bloedbaan komt?',
      [
        'Absorptie',
        'Distributie',
        'Metabolisme',
        'Uitscheiding',
      ],
      0,
      'Absorptie is het proces waarbij een geneesmiddel vanaf de toedieningsplaats in de bloedbaan terechtkomt.',
    ],
    [
      'Een agonist verschilt van een antagonist omdat hij:',
      [
        'Bindt en activeert de receptor',
        'Een receptor blokkeert zonder respons op te wekken',
        'Enzymactiviteit irreversibel verhoogt',
        'Medicijnmetabolisme in de lever voorkomt',
      ],
      0,
      'Een agonist bindt en activeert een receptor; een antagonist bindt zonder activatie.',
    ],
    [
      'Wat is geneesmiddelhalf-life?',
      [
        'Tijd tot plasmaconcentratie 50% afneemt',
        'De tijd totdat maximale concentratie bereikt is',
        'De totale tijd dat een geneesmiddel in het lichaam blijft',
        'De duur van het therapeutisch effect',
      ],
      0,
      'Half-life is de tijd tot 50% afname van plasmaconcentratie; voorspelt accumulatie bij herhaalde dosering.',
    ],
    [
      'Welk orgaan is primair verantwoordelijk voor medicijnmetabolisme?',
      [
        'Lever',
        'Nier',
        'Maag',
        'Longen',
      ],
      0,
      'De lever bevat cytochroom P450-enzymen die de meeste geneesmiddelen omzetten in afbraakproducten.',
    ],
    [
      'Wat is biologische beschikbaarheid?',
      [
        'Deel van de dosis dat de bloedbaan bereikt',
        'De geneesmiddelconcentratie op de werkingsplaats',
        'De snelheid waarmee een geneesmiddel wordt opgenomen',
        'Het vermogen van een geneesmiddel om de bloed-hersenbarrière te passeren',
      ],
      0,
      'Biologische beschikbaarheid (F) is het deel dat in systemische circulatie terechtkomt; IV = 100%.',
    ],
    [
      'Wat duidt de FDA-aanwijzing "Orphan Drug" aan?',
      [
        'Geneesmiddel voor zeldzame ziekte (<200.000 in de VS)',
        'Een geneesmiddel zonder patent of merkbescherming',
        'Een niet-goedgekeurd experimenteel middel in vroege proeven',
        'Een geneesmiddel zonder bekende fabrikant of leveringsketen',
      ],
      0,
      'Orphan Drug-status stimuleert de ontwikkeling van behandelingen voor zeldzame ziekten door middel van uitgebreide patentbescherming.',
    ],
    [
      'Wat is een geneesmiddel-geneesmiddel-interactie?',
      [
        'Effect op werkzaamheid via een ander geneesmiddel',
        'Competitie tussen twee geneesmiddelen voor dezelfde receptorplaats',
        'De chemische reactie tussen twee geneesmiddelmoleculen in oplossing',
        'De opeenvolgende toediening van twee medicijnen op dezelfde dag',
      ],
      0,
      'Interacties treden op wanneer één geneesmiddel de absorptie, het metabolisme of de werking van een ander geneesmiddel verandert.',
    ],
    [
      'Welke toedieningsroute heeft doorgaans de langzaamste absorptie?',
      [
        'Transdermaal',
        'Intraveneus',
        'Oraal',
        'Intramusculair',
      ],
      0,
      'Transdermale pleisters leveren geneesmiddelen langzaam af; IV is onmiddellijk, oraal/IM intermediair.',
    ],
    [
      'Wat betekent "generiek" voor een geneesmiddel?',
      [
        'Zonder patentbescherming, door elke fabrikant gemaakt',
        'Een ongemerkt geneesmiddel dat minder werkzaam is dan het origineel',
        'Een geneesmiddel dat voor meerdere ziekten werkt',
        'Een geneesmiddel in vroegste ontwikkelingsfase',
      ],
      0,
      'Een generiek geneesmiddel bevat dezelfde werkzame stof zonder patentbescherming; de bio-equivalentie is geverifieerd.',
    ],
    [
      'Wat veroorzaakt een type A-bijwerking?',
      [
        'Een overdreven, voorspelbare respons',
        'Een eigenaardige reactie los van farmacologie',
        'Een allergische of immuungemedieerde respons',
        'Een reactie die alleen na lange-termijngebruik optreedt',
      ],
      0,
      'Type A (vergrote) reacties zijn dosisafhankelijk en farmacologisch voorspelbaar.',
    ],
    [
      'Wat is de primaire component van een farmaceutische formulering die werkzame stof oplost?',
      [
        'Excipient',
        'Bindmiddel',
        'Conserveermiddel',
        'Chelatormiddel',
      ],
      0,
      'Excipiënten zijn inerte stoffen die medicijnafgifte mogelijk maken; ze vormen de formuleringsmassa.',
    ],
  ],
  msc: [
    [
      'Wat is allosterische modulatie?',
      [
        'Regulatie via binding op een plaats ver van de orthosterische',
        'Onomkeerbare remming van enzym op actieve plaats',
        'Competitieve remming waarbij remmer en substraat dezelfde bindingsplaats innemen',
        'Verzadiging van enzymkinetiek bij hoge substraatconcentraties',
      ],
      0,
      'Allosterische binding verandert receptorconformatie; verhoogt affiniteit zonder directe competitie.',
    ],
    [
      'Welk cytochroom P450-enzym metaboliseert ongeveer 25% van alle geneesmiddelen?',
      [
        'CYP3A4',
        'CYP2D6',
        'CYP2C9',
        'CYP1A2',
      ],
      0,
      'CYP3A4 is het meest talrijke hepatische enzym dat de meeste geneesmiddelen metaboliseert.',
    ],
    [
      'Wat is het primaire verschil in statistisch ontwerp tussen Fase I en II?',
      [
        'Fase I is open-label veiligheid; Fase II is gerandomiseerd',
        'Fase I neemt patiënten op; Fase II gezonde vrijwilligers',
        'Fase I gebruikt crossover-ontwerpen; Fase II gebruikt parallelle groepen',
        'Fase I beoordeelt metabolisme; Fase II beoordeelt klaring',
      ],
      0,
      'Fase I prioriteert veiligheid in open cohorten; Fase II voegt werkzaamheid toe met randomisatie.',
    ],
    [
      'Wat beschrijven farmacodynamische modellen met Emax-vergelijkingen?',
      [
        'De sigmoidale relatie tussen concentratie en effect',
        'De lineaire eliminatie van geneesmiddel in stabiele toestand',
        'De absorptiesnelheid over het maagdarmkanaal',
        'Het distributievolume in verschillende weefselcompartimenten',
      ],
      0,
      'Emax-modellen relateren effect aan concentratie via maximale respons en potentie (EC50).',
    ],
    [
      'Hoe beïnvloedt geneesmiddelchiraliteit farmacokinetiek?',
      [
        'Enantiomeren metaboliseren mogelijk verschillend snel',
        'Chirale geneesmiddelen worden altijd sneller opgenomen dan achirale',
        'Chiraliteit heeft geen effect op farmacokinetiek, alleen op potentie',
        'Enantiomeren worden snel omgezet in bloedbaan',
      ],
      0,
      'Enantiomeren kunnen sterk verschillende metabolisme en transporteraffiniteit vertonen.',
    ],
    [
      'Wat is first-pass metabolisme?',
      [
        'Pre-systemisch hepatisch of intestinaal metabolisme',
        'Initiële eliminatie van geneesmiddel tijdens absorptiefase',
        'Metabolisme van geneesmiddel door de nier',
        'Omzetting van inactief prodrug in werkzame vorm',
      ],
      0,
      'First-pass metabolisme (pre-systemisch) treedt op tijdens portalcirculatie-doorgang.',
    ],
    [
      'Hoe beïnvloedt plasmaeiwit-binding farmacokinetiek?',
      [
        'Lagere vrije concentratie en veranderde klaring',
        'Eiwitbinding verhoogt het distributievolume gelijkmatig',
        'Gebonden geneesmiddel draagt net zo goed bij aan het effect als vrij geneesmiddel',
        'Eiwitbinding heeft geen kinetische gevolgen',
      ],
      0,
      'Alleen vrij geneesmiddel wordt geklaard of oefent effect uit; binding vermindert klaring.',
    ],
    [
      'Wat is het werkingsmechanisme van bètablokkers?',
      [
        'Adrenerge antagonisme',
        'Agonisme op muscarinische acetylcholinereceptoren',
        'Blokkering van calciumkanalen',
        'Directe vaatverwijding via stikstofmonoxide',
      ],
      0,
      'Bètablokkers remmen competitief noradrenaline/adrenaline op β-adrenerge receptoren.',
    ],
    [
      'Wat is een prodrug?',
      [
        'Een inactieve verbinding, gemetaboliseerd tot actieve vorm',
        'Een geneesmiddeltussenproduct tijdens productie',
        'Een gedeeltelijk werkzaam geneesmiddel dat combinatietherapie vereist',
        'Een geneesmiddel in vroegste preklinische fase',
      ],
      0,
      'Prodrugs zijn inactief; metabolisme zet ze om in actieve afbraakproducten.',
    ],
    [
      'Wat bepaalt concentratie op stabiel niveau voor gegeven doseringsinterval?',
      [
        'Klaring t.o.v. doseerinterval',
        'Alleen distributievolume',
        'Absorptiesnelheidsconstante',
        'Bindingsaffiniteit met plasma-eiwitten',
      ],
      0,
      'Op een stabiel niveau is de invoer gelijk aan de eliminatie. Accumulatie hangt af van de half-life ten opzichte van de dosering.',
    ],
    [
      'Wat is farmacogenomica?',
      [
        'Genetische variatie in medicijnmetaboliserende enzymen',
        'Ontwikkeling van nieuwe chemische entiteiten uit genetisch materiaal',
        'Gebruik van geneesmiddelen om genexpressie te veranderen',
        'Erfenis van medicijnmetabolismepatronen tussen generaties',
      ],
      0,
      'Farmacogenomica onderzoekt hoe genetische polymorfismen metabolisme, werkzaamheid en bijwerkingen beïnvloeden.',
    ],
    [
      'Welke rol spelen medicijntransporters in farmacokinetiek?',
      [
        'Actief transport van geneesmiddelen over membranen',
        'Passieve diffusie van alle geneesmiddelen over bloed-hersenbarrière',
        'Binding van geneesmiddelen aan dragereiwitten in plasma',
        'Inactivering van geneesmiddelen door enzymatische afbraak',
      ],
      0,
      'Transporters pompen geneesmiddelen actief uit cellen. Dit beïnvloedt de GI-absorptie en de hepatische klaring.',
    ],
    [
      'Waarom kan een Fase III-proef mislukken ondanks succes in Fase II?',
      [
        'Grotere groepen onthullen zwakke respons',
        'Fase III vereist andere parameters dan Fase II',
        'Geneesmiddelmetabolisme verandert met grotere steekproeven',
        'Regelgeving is strenger voor Fase III',
      ],
      0,
      'Fase III werft veel meer deelnemers in; zeldzame of groepspecifieke bijwerkingen komen naar voren.',
    ],
    [
      'Wat is een aannemelijke verklaring voor verlies van werkzaamheid na langdurig gebruik?',
      [
        'Receptordesensibilisatie of downregulatie',
        'Verhoogd geneesmiddelmetabolisme in loop der tijd',
        'Nierfalen dat zich tijdens therapie ontwikkelt',
        'Afbraak van geneesmiddelmolecuul in bloedbaan',
      ],
      0,
      'Chronische agonist-blootstelling veroorzaakt receptordesensibilisatie of downregulatie.',
    ],
    [
      'Wat is de betekenis van CYP450-inductie in geneesmiddel-interacties?',
      [
        'Het verhoogt expressie van metabolische enzymen',
        'Inductie voorkomt geneesmiddelmetabolisme',
        'Inductie treedt alleen op met chronische dosering van één geneesmiddel',
        'Inducers blokkeren transportergemedieerde klaring',
      ],
      0,
      'Inducers verhogen CYP450-expressie; versnellen metabolisme van gelijktijdig gegeven substraten.',
    ],
  ],
  phd: [
    [
      'Wat is positieve allosterische modulatie (PAM) en hoe verschilt het mechanistisch van orthosterisch agonisme?',
      [
        'PAM verhoogt affiniteit zonder directe activering',
        'PAMs hebben langzamere kinetiek dan agonisten',
        'PAMs beïnvloeden alleen G-proteïne-gekoppelde receptoren',
        'PAMs verhogen receptorexpressie terwijl agonisten signalering verhogen',
      ],
      0,
      'PAMs verschuiven de agonist dosis-responscurve; agonisten activeren direct op de orthosterische plaats.',
    ],
    [
      'Hoe bepalen CYP450-remmingskinetiek (competitief vs mechanisme-gebonden) DDI-ernst?',
      [
        'Mechanisme-gebonden remmers werken irreversibel',
        'Niet-competitieve remming is altijd omkeerbaar',
        'Competitieve remming produceert altijd klinische DDI\'s, niet-competitieve remming niet',
        'Beide zijn even tijdafhankelijk',
      ],
      0,
      'Competitieve remming is omkeerbaar; mechanisme-gebonden remmers inactiveren enzym permanent.',
    ],
    [
      'Wat is het primaire doel van fysiologisch gebaseerde farmacokinetische (PBPK) modellering?',
      [
        'Weefselconcentraties fysiologisch voorspellen',
        'Klinische proeven vervangen door in silico-simulaties',
        'Bepalen of geneesmiddel bloed-hersenbarrière passeert',
        'Distributievolume voor alle geneesmiddelen berekenen',
      ],
      0,
      'PBPK integreert weefselperfusie en enzymkinetiek voor voorspelling van lichaamsbrede PK.',
    ],
    [
      'Wat onderscheidt vertekende signalering op GPCRs en waarom is het farmacologisch belangrijk?',
      [
        'Liganden activeren selectief één signaalweg boven ander',
        'Vertekende signalering betekent dat receptor wordt geremd',
        'Alle GPCR-agonisten activeren identieke intracellulaire routes',
        'Vertekende signalering treedt alleen op met antagonisten',
      ],
      0,
      'Vertekend agonisme benut selectieve werkzaamheid; het kan therapeutische effecten van toxiciteit scheiden.',
    ],
    [
      'Hoe wordt de PK/PD-index (bijv. AUC/MIC, Cmax/MIC) geoptimaliseerd voor werkzaamheidsvoorspelling?',
      [
        'Data worden aan sigmoidale PK/PD-modellen aangepast',
        'PK/PD-indices zijn vaste getallen onafhankelijk van geneesmiddel',
        'Alleen AUC is relevant; piekconcentratie (Cmax) is irrelevant',
        'PK/PD-indices worden achteraf na goedkeuring berekend',
      ],
      0,
      'PK/PD-indexoptimalisatie gebruikt doseeronderzoeken voor de blootstelling-responsrelatie.',
    ],
    [
      'Door welk mechanisme kan substraatremming van CYP450 paradoxaal de eigen metabolische activiteit verhogen?',
      [
        'Het activeert het enzym zelf allosterisch',
        'Substraatremming verlaagt altijd enzymactiviteit',
        'CYP450-enzymen kunnen niet allosterisch worden gemodelleerd',
        'Substraatremming beïnvloedt alleen nierfunctie',
      ],
      0,
      'Sommige CYP450s (vooral CYP3A4) vertonen allosterische substraatbinding die katalyse activeert.',
    ],
    [
      'Wat is het werkingsmechanisme van direct werkende antiviralia (DAAs) in hepatitis C en waarom transformeerden zij behandeling?',
      [
        'DAAs remmen een viraal NS-enzym direct',
        'DAAs remmen de immuunrespons van de gastheer',
        'DAAs werken door interferon-alfa-productie te stimuleren',
        'DAAs zijn gericht op hepatitis C-antistoffen',
      ],
      0,
      'HCV-DAA\'s blokkeren virale replicatie-enzymen en transformeerden hepatitis C in een geneesbare ziekte.',
    ],
    [
      'Hoe beïnvloeden P-glycoproteïne (MDR1/ABCB1) transporters orale beschikbaarheid en CNS-penetratie?',
      [
        'P-gp voert substraten actief af uit enterocyten en de BBB',
        'P-gp verhoogt absorptie van alle geneesmiddelen in darm',
        'P-gp heeft geen effect op de bloed-hersenbarrière',
        'P-gp transporteert alleen grote moleculen',
      ],
      0,
      'P-gp stoot substraten actief uit GI-enterocyten en BBB-endotheel uit; remmers verhogen de blootstelling.',
    ],
    [
      'Wat is stereoselectief metabolisme en hoe bemoeilijkt het enantiomale medicijnontwerp?',
      [
        'Enzymen metaboliseren selectief één enantiomeer',
        'Stereoselectief metabolisme treedt alleen in de lever op',
        'Beide enantiomeren worden altijd met identieke snelheid gemetaboliseerd',
        'Stereoselectief metabolisme beïnvloedt alleen peptidegeneesmiddelen',
      ],
      0,
      'CYP450s onderscheiden stereochemie; enantiomere geneesmiddelen kunnen langere half-lives hebben.',
    ],
    [
      'Wat zijn de sleutelcomponenten van doelvalidatie in medicijnontdekking?',
      [
        'Bewijs voor de koppeling tussen modulatie en fenotype',
        'Testen of verbinding aan voorgestelde doel bindt',
        'Bevestiging van expressieniveaus op de ziekteplaats',
        'Evaluatie van off-target bindingsprofielen',
      ],
      0,
      'Doelvalidatie vereist causale koppelingen: genetische verstoring, farmacologische remming, fenotypeverandering.',
    ],
    [
      'Hoe worden steekproefgrootten voor Fase II dosis-escalatieproeven berekend en welke statistieken gelden?',
      [
        'Gebaseerd op het minimaal belangrijke verschil',
        'Fase II-proeven vereisen geen statistische planning',
        'Steekproefgrootten in Fase II zijn altijd groter dan Fase III',
        'Fase II-proeven gebruiken geen controlegroepen',
      ],
      0,
      'Fase II-steekproefgrootten worden berekend op basis van het minimaal belangrijke PK/PD- of werkzaamheidsverschil, met correctie voor veelvoudigheid.',
    ],
    [
      'Wat is een CYP2D6-armmetabolizer-genotype en hoe beïnvloedt het de codeïnewerkzaamheid?',
      [
        'Het blokkeert omzetting van codeïne naar morfine',
        'Armmetabolizers hebben verbeterde codeïnewerkzaamheid',
        'CYP2D6-status beïnvloedt alleen paracetamolmetabolisme',
        'Armmetabolizers zijn zeldzaam en klinisch irrelevant',
      ],
      0,
      'CYP2D6-armmetabolizers kunnen codeïne-prodrug niet activeren tot morfine; ultra-snelle metabolizers hebben een toxiciteitsrisico.',
    ],
    [
      'Welke rol spelen OATP-transporters in hepatische klaring en DDI-potentieel van atorvastatine?',
      [
        'OATP1B1/1B3-opname is snelheidsbepalend',
        'OATP-transporters voeren geneesmiddelen uit hepatocyten uit',
        'Atorvastatine wordt uitsluitend gemetaboliseerd door CYP3A4',
        'OATP-remming verlaagt altijd geneesmiddel-werkzaamheid',
      ],
      0,
      'OATP1B1/1B3 mediëren sinusoïdale opname; remmers verlagen de atorvastatine-klaring 3- tot 4-voudig.',
    ],
    [
      'Wat is een "mechanistische biomarker" in klinische proeven, en hoe verschilt het van "klinisch eindpunt"?',
      [
        'Ze weerspiegelen doelengagement, niet uitkomsten',
        'Mechanistische biomarkers en klinische eindpunten zijn hetzelfde',
        'Klinische eindpunten zijn altijd sneller te beoordelen dan biomarkers',
        'Mechanistische biomarkers voorspellen klinische eindpunten met 100% nauwkeurigheid',
      ],
      0,
      'PD-biomarkers weerspiegelen doelengagement; klinische eindpunten vereisen grotere, langere proeven.',
    ],
    [
      'Waarom kan niet-lineaire farmacokinetiek (capaciteitsgrenzen metabolisme) exponentiële blootstelling-stijging veroorzaken?',
      [
        'Enzymverzadiging laat de klaring dalen bij een hogere dosis',
        'Niet-lineaire kinetiek treedt alleen op bij zeer hoge geneesmiddelconcentraties',
        'Niet-lineaire kinetiek vereenvoudigt doseerberekeningen',
        'Alle geneesmiddelen volgen lineaire kinetiek in alle dosierbereiken',
      ],
      0,
      'Capaciteitsgrenzen-metabolisme toont exponentiële stijging; een kleine doseverhoging veroorzaakt een grote AUC-sprong.',
    ],
  ],
  professor: [
    [
      'Wat is coöperatief effect in allosterische modulatie, en hoe voorspelt Hill-coëfficiënt >1 bindingsgedrag?',
      [
        'Hill n>1 duidt op positief coöperatief effect',
        'Hill-coëfficiënten zijn altijd onafhankelijk van bindingsmechanisme',
        'Coöperatief effect is irrelevant voor GPCR-signalering',
        'Hill n>1 duidt altijd op agonisme in plaats van allosterisme',
      ],
      0,
      'Coöperatief effect vloeit voort uit allosterische communicatie; n>1 produceert een steilere curve dan bij één bindingsplaats.',
    ],
    [
      'Hoe onthullen meta-analyses van CYP3A4-remming risicostratificatie voor medicijninteracties?',
      [
        'Gerangschikt naar AUC-verandering van substraten',
        'Alle CYP3A4-remmers produceren identieke DDI\'s',
        'Substraatconcentratie is irrelevant voor DDI-ernst',
        'CYP3A4-remming treedt altijd op in stabiele toestand',
      ],
      0,
      'De FDA/EMA-richtlijn rangschikt remmers naar AUC-verandering; smalle-index-substraten vereisen dosisaanpassing.',
    ],
    [
      'Wat zijn de mechanistische principes van PBPK-modelextrapolatie van in vitro-klaring naar in vivo farmacokinetiek?',
      [
        'In vitro CLint wordt geschaald met bloedstroom',
        'PBPK-modellen negeren in vitro-gegevens',
        'Schaalfactoren zijn niet nodig voor in vitro naar in vivo-omzetting',
        'PBPK-modellen voorspellen klinische PK altijd perfect',
      ],
      0,
      'PBPK gebruikt well-stirred-modellen om CLint te schalen; absolute beschikbaarheid hangt af van enterocytafzetting.',
    ],
    [
      'Hoe wordt vertekende signalering via β-arrestine-pathway-activatie bij muscarinische receptoren therapeutisch benut?',
      [
        'β-arrestine activeert MAPK/ERK zonder G-proteïne',
        'β-arrestine bemiddelt altijd dezelfde effecten als G-proteïne-signalering',
        'β-arrestine-koppeling treedt alleen op remmende receptoren op',
        'Therapeutische selectiviteit vereist gelijktijdige G-proteïne- en β-arrestine-activering',
      ],
      0,
      'M1 PAMs activeren β-arrestine selectief; dit ontkoppelt cognitieve effecten van cholinergische bijwerkingen.',
    ],
    [
      'Hoe worden populatie PK/PD-modellen met Bayesiaanse voorspelling gebruikt voor pediatrische dosering optimalisatie?',
      [
        'Allometrische schaling past zich aan de pediatrische fysiologie aan',
        'Pediatrische dosering is altijd fractie van volwassenendose',
        'Bayesiaanse voorspelling wordt alleen in oudere populaties gebruikt',
        'Populatie PK-modellen negeren rijping van medicijnmetaboliserende enzymen',
      ],
      0,
      'Populatie PK gebruikt priorverdelingen; allometrische exponenten (0.75 voor CL, 1.0 voor V) corrigeren voor lichaamsgrootte en rijping.',
    ],
    [
      'Wat is het mechanisme van een drievoudige medicijn-medicijn-gen-interactie, en hoe kan armmetabolizerstratificatie hierbij helpen?',
      [
        'Concurrerende PK- en farmacogenomische effecten',
        'Drievoudige interacties kunnen niet klinisch worden voorspeld',
        'Gen-geneesmiddel-interacties zijn altijd verwaarloosbaar',
        'Drievoudige interacties treden alleen bij zeer hoge doses op',
      ],
      0,
      'CYP2D6-armmetabolizers die ook concurrerende CYP3A4-modificatoren gebruiken, ervaren een veranderde blootstelling; de fenotypevoorspelling is complex.',
    ],
    [
      'Hoe voorspellen substraat- vs. remmings- vs. inductie-hiërarchieën de DDI-ernst op CYP3A4, OATP1B1 en P-gp?',
      [
        'Hangt af van affiniteit en Cmax-naar-Ki',
        'Alle substraten interageren identiek met remmers',
        'Hiërarchieën zijn onafhankelijk van geneesmiddelconcentratie',
        'Inducers veroorzaken nooit klinisch significante DDI\'s',
      ],
      0,
      'De FDA-richtlijn rangschikt substraten en remmers naar drempelwaardeveranderingen; een hoge Cmax/Ki vormt het hoogste DDI-risico.',
    ],
    [
      'Hoe interageren stereoselektieve transporters (bijv. L-DOPA-afzet via OATP3) en metabolisme voor enantiomale beschikbaarheid?',
      [
        'Transportselectiviteit kan metabolisme overschrijden',
        'Transporters onderscheiden niet tussen enantiomeren',
        'Metabolisme domineert altijd transportergemedieerde klaring',
        'Stereoselektiviteit geldt alleen voor metabolisme',
      ],
      0,
      'OATP3-gemedieerde L-DOPA-afzet is stereoselectief; remmers kunnen mogelijk hergebruik van het inactieve enantiomeer bevorderen.',
    ],
    [
      'Wat zijn fasen van doelvalidatie in oncologie, en hoe verschillen zij van infectieuze ziekte-doelvalidatie?',
      [
        'Oncologie gebruikt PDX-modellen; ID resistentiestudies',
        'Oncologie en ID-doelvalidatie zijn identieke processen',
        'Oncologie-doelen vereisen geen preklinische validatie',
        'ID-doelen worden uitsluitend in diermodellen gevalideerd',
      ],
      0,
      'Oncologie benadrukt genotype-fenotype koppeling; ID richt zich op mechanistisch virulentieverlies en resistentiebelemmeringen.',
    ],
    [
      'Hoe worden adaptieve Fase II-proefontwerpen (bijv. naadloos Fase II/III) statistisch beheerst voor veelvoudigheid?',
      [
        'Alfa-besteding beheerst de fout bij tussentijdse analyses',
        'Adaptieve proeven vereisen geen statistische aanpassingen',
        'Naadloze ontwerpen overschrijden altijd Type I-foutsnelheid',
        'Adaptieve ontwerpen zijn niet acceptabel voor FDA/EMA',
      ],
      0,
      'FDA/EMA steunen vooraf bepaalde tussentijdse analyses (Pocock/O\'Brien-Fleming) met alfa-toewijzing voor dosisbepaling.',
    ],
    [
      'Wat is de rol van epigenetische wijzigingen (DNA-methylering, histone-acetylering) in farmacogeen-expressie modulatie?',
      [
        'Differentiële promotermethylering verandert enzymexpressie',
        'Epigenetische wijzigingen zijn irrelevant voor medicijnmetabolisme',
        'Methyleringspatronen zijn vast en verschillen niet tussen weefsels',
        'Alleen genetische polymorfismen hebben belang voor medicijnmetabolisme',
      ],
      0,
      'CYP450-promotermethylering dempt de expressie bij sommige mensen; dit correleert met een veranderde metabolismesnelheid.',
    ],
    [
      'Hoe beïnvloedt mechanistisch niet-lineaire farmacokinetiek (verzadigde CLint, renale reabsorptie) labeldosering en TDM?',
      [
        'Verzadigbaar metabolisme geeft dosisafhankelijke half-lives',
        'Alle geneesmiddelen volgen lineaire kinetiek; TDM onnodig',
        'Niet-lineariteit beïnvloedt alleen renale uitscheiding',
        'Therapeutische medicijnmonitoring is altijd onnauwkeurig voor niet-lineaire geneesmiddelen',
      ],
      0,
      'Fenytoïne en salicylaten tonen verzadigd metabolisme; dosisafhankelijke half-lives vereisen TDM.',
    ],
    [
      'Wat zijn transportergemedieerde PK/PD-biomarkers, en hoe kunnen zij patiëntstratificatie in nier-/leverziekte verfijnen?',
      [
        'Transporteractiviteit voorspelt individuele klaringsvariatie',
        'Transporters hebben geen invloed op ziekte-specifieke geneesmiddelklaring',
        'Transporterfunctie kan niet klinisch worden gemeten',
        'Nierziekte verlaagt altijd geneesmiddelklaring evenredig',
      ],
      0,
      'Transporteractiviteit voorspelt de hepatische geneesmiddelklaring; behouden activiteit bij CKD is relevant voor renaal uitgescheiden geneesmiddelen.',
    ],
    [
      'Hoe beïnvloeden regelgevingsroutes (505(b)(1) NDA, 505(b)(2), ANDA) de tijdlijn voor generieke medicijnontwikkeling?',
      [
        'ANDA vereist alleen bio-equivalentie, geen nieuwe proeven',
        'Alle geneesmiddelgoedkeuringen volgen identieke regelgevingsroutes',
        '505(b)(1) en 505(b)(2) hebben gelijkwaardige vereisten',
        'Generieke geneesmiddelen vereisen geen FDA-goedkeuring',
      ],
      0,
      'Generieke route (ANDA) vereist bio-equivalentie zonder klinische proeven; de tijdlijn na patentverval is versneld.',
    ],
    [
      'Hoe informeren mechanistische inzichten uit klinische proefmislukkingen (bijv. de ENHANCE-studie, de terugtrekking van lorcaserine) de na-analyse van PK/PD-gegevens?',
      [
        'Mechanismegerichte analyses leiden tot reddings- of stopbeslissingen',
        'Klinische mislukkingen zijn altijd eindpunten',
        'Post-hoc PK/PD-analyses kunnen de veiligheid in nieuwe populaties niet voorspellen',
        'Mechanismemislukkingen zijn onomkeerbaar',
      ],
      0,
      'ENHANCE mislukte ondanks LDL-verlaging, waarbij niet-lipidemechanismen aan het licht kwamen. Lorcaserine bleek hartklepziekte te veroorzaken.',
    ],
  ],
};
